import React from "react";

const IconBank = props => (
  <svg
    {...props}
    viewBox="0 0 40 40"
    fill="none"
    className="svg-icon"
  >
    <path d="M20 4L3 13h34L20 4z" fill="#1A73E8" />
    <rect x="6" y="15" width="4" height="13" rx="1" fill="#1A73E8" />
    <rect x="14" y="15" width="4" height="13" rx="1" fill="#1A73E8" />
    <rect x="22" y="15" width="4" height="13" rx="1" fill="#1A73E8" />
    <rect x="30" y="15" width="4" height="13" rx="1" fill="#1A73E8" />
    <rect x="3" y="30" width="34" height="3" rx="1" fill="#1A73E8" />
    <rect x="1" y="34" width="38" height="3" rx="1" fill="#1A73E8" />
  </svg>
);

export default IconBank;
